import axios from "axios";
export default {
  allReceivingsReport: (params, cancelToken) =>
    axios.get(`/api/receivings/export/all`, { cancelToken, params, responseType: "blob" }),
};
